import React from "react";

import "./index.scss";

interface HospitalCardEmptyStateProps {
  title?: string;
}

export default function HospitalCardEmptyState(props: HospitalCardEmptyStateProps) {
  const { title } = props;
  return (
    <div className="hospital-card-empty-state">
      <div className="hospital-card-empty-state-title">{title || "No Items to Display"}</div>
    </div>
  );
}
